import { useSnackbar } from 'notistack';
import { useQuery } from 'react-query';
import { useHttp } from 'shared/providers/provide-http';
import { PriceHistoryData, TableDataResponse } from 'types/backend';
import { useTableDataRequest } from './useTableDataRequest';
import { GridSortDirection } from '@mui/x-data-grid-premium';

export function useGetPriceHistory(id: string, field: string, sort: GridSortDirection) {
    const { debouncedTableDataRequest, serverSideProps, setTableDataRequest, resetPageNumber } = useTableDataRequest(
        {}
    );

    const { enqueueSnackbar } = useSnackbar();
    const http = useHttp();

    const response = useQuery<TableDataResponse<PriceHistoryData>, Error>(
        ['Individual Price History', debouncedTableDataRequest, id],
        async () => {
            if (!id) return [];
            const { data } = await http.post(`api/pricehistory/subset/${id}`, {
                debouncedTableDataRequest,
                SortModel: [
                    {
                        field,
                        sort,
                    },
                ],
            });
            return data || [];
        },
        {
            onError: (error) => enqueueSnackbar(error.message, { variant: 'error' }),
            keepPreviousData: false,
            refetchOnWindowFocus: false,
        }
    );

    return {
        resetPageNumber,
        response,
        setTableDataRequest,
        debouncedTableDataRequest,
        serverSideProps,
    };
}
